import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { Modal } from "reactstrap";
import Swal from 'sweetalert2';
import API from '../../API';
import moment from 'moment';
import { createRoot } from 'react-dom/client';
import { useForm, Controller, set } from "react-hook-form";
import { DataTable } from '..';
import { DateFormat, DateThaiFormat, GetAPIURL, GetAuthorization, NumberFormat, GradeLevelName } from '../../Utils/Function';
import PDFViewCard from '../PDFViewCard';
import { ThaiDatePicker } from "thaidatepicker-react";
import { TimePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
const ProjectCard = forwardRef((props, ref) => {
    const [_ModalViewState, setModalViewState] = useState(false);
    const _PDFViewCard = useRef();
    const { register, getValues, setValue, control } = useForm();
    const _FileInputRef = useRef();
    const [_ProjectGroupList, setProjectGroupList] = useState([]);
    const [_ProjectID, setProjectID] = useState(null);
    const [_ProjectGroupID, setProjectGroupID] = useState(0);
    const [_Status, setStatus] = useState(0);
    const [_CourseList, setCourseList] = useState([]);
    const [_GradeLevel, setGradeLevel] = useState(0);
    const [_CourseMember, setCourseMember] = useState([]);
    const [_CourseID, setCourseID] = useState(null);

    const [_ApplicationStart, setApplicationStart] = useState(null);
    const [_ApplicationEnd, setApplicationEnd] = useState(null);
    const [_SubmitStart, setSubmitStart] = useState(null);
    const [_SubmitEnd, setSubmitEnd] = useState(null);
    const [_CandidateDate, setCandidateDate] = useState(null);

    const [_ExamDateStart, setExamDateStart] = useState(null);
    const [_ExamDateEnd, setExamDateEnd] = useState(null);
    const [_ExamTimeStart, setExamTimeStart] = useState(null);
    const [_ExamTimeEnd, setExamTimeEnd] = useState(null);

    const [_InterviewDateStart, setInterviewDateStart] = useState(null);
    const [_InterviewDateEnd, setInterviewDateEnd] = useState(null);
    const [_InterviewTimeStart, setInterviewTimeStart] = useState(null);
    const [_InterviewTimeEnd, setInterviewTimeEnd] = useState(null);

    const [_ExamResultDate, setExamResultDate] = useState(null);
    const [_ConfirmDate, setConfirmDate] = useState(null);
    useEffect(() => {
        (async () => {

        })();

        return () => {
        }
    }, []);

    useImperativeHandle(ref, () => ({
        Show(ProjectID) {
            _LoadProjectGroup();
            console.log(ProjectID);
            if (ProjectID != null) {
                //setProjectID(ProjectID);
                _LoadProject(ProjectID);
            } else {
                _Clear();
                setModalViewState(true);
            }
        }
    }));
    const _LoadProject = async (ProjectID) => {
        API({ method: "get", url: "/Staff/Project/" + ProjectID }).then(res => {
            if (res.data.Status) {
                _LoadCourseList(res.data.Detail.GradeLevel);
                setProjectGroupID(res.data.Detail.ProjectGroupID);
                setProjectID(res.data.Detail.ProjectID);
                setStatus(res.data.Detail.Status);
                setGradeLevel(res.data.Detail.GradeLevel);
                setValue("ProjectName", res.data.Detail.ProjectName);
                setValue("Description", res.data.Detail.Description);
                setValue("CourseLimit", res.data.Detail.CourseLimit);
                setValue("CodePrefix", res.data.Detail.CodePrefix);
                setValue("YearEDU", res.data.Detail.YearEDU);
                setValue("Sorting", res.data.Detail.Sorting);
                setApplicationStart(res.data.Detail.ApplicationStart != null ? moment(res.data.Detail.ApplicationStart) : null);
                setApplicationEnd(res.data.Detail.ApplicationEnd != null ? moment(res.data.Detail.ApplicationEnd) : null);
                setSubmitStart(res.data.Detail.SubmitStart != null ? moment(res.data.Detail.SubmitStart) : null);
                setSubmitEnd(res.data.Detail.SubmitEnd != null ? moment(res.data.Detail.SubmitEnd) : null);
                setCandidateDate(res.data.Detail.Candidate != null ? moment(res.data.Detail.Candidate) : null);
                setExamDateStart(res.data.Detail.ExamStart != null ? moment(res.data.Detail.ExamStart) : null);
                setExamDateEnd(res.data.Detail.ExamEnd != null ? moment(res.data.Detail.ExamEnd) : null);
                setExamTimeStart(res.data.Detail.ExamStart != null ? moment(res.data.Detail.ExamStart).toDate() : null);
                setExamTimeEnd(res.data.Detail.ExamEnd != null ? moment(res.data.Detail.ExamEnd).toDate() : null);
                setInterviewDateStart(res.data.Detail.InterviewStart != null ? moment(res.data.Detail.InterviewStart) : null);
                setInterviewDateEnd(res.data.Detail.InterviewEnd != null ? moment(res.data.Detail.InterviewEnd) : null);
                setInterviewTimeStart(res.data.Detail.InterviewStart != null ? moment(res.data.Detail.InterviewStart).toDate() : null);
                setInterviewTimeEnd(res.data.Detail.InterviewEnd != null ? moment(res.data.Detail.InterviewEnd).toDate() : null);
                setExamResultDate(res.data.Detail.ExamResult != null ? moment(res.data.Detail.ExamResult) : null);
                setConfirmDate(res.data.Detail.ConfirmDate != null ? moment(res.data.Detail.ConfirmDate) : null);
                setValue("ExamTopic", res.data.Detail.ExamTopic);
                setValue("Price", res.data.Detail.Price);
                setValue("GPAX", res.data.Detail.GPAX);
                let _CourseObj = [];
                console.log(res.data.Detail.Courses);
                [...res.data.Detail.Courses].forEach((v, i) => {
                    let _Obj = { ...v.Course, Seat: v.SeatLimit };
                    _CourseObj.push(_Obj);
                })
                /**
                res.data.Detail.Courses.forEach((v,i) => {
                    let _Obj = {... v,Seat:v.SeatLimit};
                    _CourseObj.push(_Obj);
                });
                **/
                setCourseMember(_CourseObj);
            };
            setModalViewState(true);

        });
    }
    const _LoadCourseList = async (GradeLevel) => {
        setCourseList([]);
        if (GradeLevel == 0) return;

        API({ method: "get", url: "/Staff/Course/List/" + GradeLevel }).then(res => {
            setCourseList(res.data);
        });
    };
    const _LoadProjectGroup = async () => {
        setProjectGroupList([]);
        API({ method: "get", url: "/Staff/Project/Group" }).then(res => {
            setProjectGroupList(res.data);
        });

    }
    const _Clear = () => {
        setProjectID(null);
        _LoadProjectGroup();
        setStatus(0);
        setProjectGroupID(0);
        setCourseList([]);
        setCourseMember([]);
        setCourseID(null);
        setGradeLevel(0);
        setValue("ProjectName", '');
        setValue("Description", '');
        setValue("CourseLimit", '0');
        setValue("CodePrefix", '');
        setValue("YearEDU", '');
        setValue("Sorting", '');
        setValue("ExamTopic", '');
        setValue("Price",'');
        setValue("GPAX",'');
        setApplicationStart(null);
        setApplicationEnd(null);
        setSubmitStart(null);
        setSubmitEnd(null);
        setCandidateDate(null);

        setExamDateStart(null);
        setExamDateEnd(null);
        setExamTimeStart(null);
        setExamTimeEnd(null);

        setInterviewDateStart(null);
        setInterviewDateEnd(null);
        setInterviewTimeStart(null);
        setInterviewTimeEnd(null);

        setExamResultDate(null);
        setConfirmDate(null);
    }
    const _CourseAdd = () => {
        console.log(_CourseID);
        if (_CourseID == null) {
            Swal.fire({
                icon: 'error',
                title: 'กรุณาเลือกแผนการเรียน',
            });
            return;
        }
        let _CourseObj = _CourseList.find((e) => e.CourseID == _CourseID);
        //console.log(_CourseObj);
        let _Obj = [..._CourseMember];
        if (_Obj.find((e) => e.CourseID == _CourseID) != undefined) {
            Swal.fire({
                icon: 'error',
                title: 'แผนที่เลือกมีอยู่ในรายการแล้ว',
            });
            return;
        }
        _Obj.push(_CourseObj);
        setCourseMember(_Obj);
    }

    const _Save = async () => {
        const _reqObj = {
            ProjectID: _ProjectID,
            ProjectGroupID: Number(_ProjectGroupID),
            ProjectName: getValues("ProjectName"),
            CourseLimit: Number(getValues("CourseLimit")),
            Sorting: Number(getValues("Sorting")),
            CodePrefix: getValues("CodePrefix"),
            YearEDU: getValues("YearEDU"),
            Status: Number(_Status),
            GradeLevel: Number(_GradeLevel),
            ApplicationStart: (_ApplicationStart != null ? moment(_ApplicationStart).format("YYYY-MM-DD") : null),
            ApplicationEnd: (_ApplicationEnd != null ? moment(_ApplicationEnd).format("YYYY-MM-DD") : null),
            SubmitStart: (_SubmitStart != null ? moment(_SubmitStart).format("YYYY-MM-DD") : null),
            SubmitEnd: (_SubmitEnd != null ? moment(_SubmitEnd).format("YYYY-MM-DD") : null),
            Candidate: (_CandidateDate != null ? moment(_CandidateDate).format("YYYY-MM-DD") : null),
            ExamStart: (_ExamDateStart != null && _ExamTimeStart != null ? moment(_ExamDateStart).format("YYYY-MM-DD") + ' ' + moment(_ExamTimeStart).format("HH:mm") : null),
            ExamEnd: (_ExamDateEnd != null && _ExamTimeEnd != null ? moment(_ExamDateEnd).format("YYYY-MM-DD") + ' ' + moment(_ExamTimeEnd).format("HH:mm") : null),
            InterviewStart: (_InterviewDateStart != null && _InterviewTimeStart != null ? moment(_InterviewDateStart).format("YYYY-MM-DD") + ' ' + moment(_InterviewTimeStart).format("HH:mm") : null),
            InterviewEnd: (_InterviewDateEnd != null && _InterviewTimeEnd != null ? moment(_InterviewDateEnd).format("YYYY-MM-DD") + ' ' + moment(_InterviewTimeEnd).format("HH:mm") : null),
            ExamResult: (_ExamResultDate != null ? moment(_ExamResultDate).format("YYYY-MM-DD") : null),
            ConfirmDate: (_ConfirmDate != null ? moment(_ConfirmDate).format("YYYY-MM-DD") : null),
            ExamTopic: getValues("ExamTopic"),
            Description: getValues("Description"),
            Price: getValues("Price"),
            GPAX:Number(getValues("GPAX")),
            Courses: []
        }
        let _CourseObj = [];
        _CourseMember.forEach((v, i) => {
            _CourseObj.push({ CourseID: v.CourseID, SeatLimit: v.Seat });
        })
        _reqObj.Courses = _CourseObj;

        API({ method: "post", url: "/Staff/Project/Save", data: _reqObj }).then(res => {
            if (res.data.Status) {
                setProjectID(res.data.ProjectID);
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลเสำร็จ',
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
            }
        });
    }
    const _Upload = async () => {
        _FileInputRef.current.value = null;
        _FileInputRef.current.click();
    }
    const _RegisterFileUpload = async (e) => {
        const fd = new FormData();
        fd.append("File", _FileInputRef.current.files[0]);
        Swal.showLoading();
        API({ method: "post", url: '/Staff/Project/' + _ProjectID + '/Upload', data: fd, headers: { "Content-Type": "multipart/form-data" } }).then(res => {
            if (res.data.Status) {
                Swal.fire({
                    icon: 'success',
                    title: 'อัพโหลดไฟล์สำเร็จ',
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
            }
        })
            .catch(error => {
                console.log("Server Error : ", error);
                Swal.close();
            });

    }
    const _PDF = async () => {
        _PDFViewCard.current?.Show(GetAPIURL() + "/Member/Project/" + _ProjectID + "/" + sessionStorage.getItem("Authorization") + "/PDF", "ไฟล์เอกสารแนบ");
    }
    return (
        <>
            <Modal isOpen={_ModalViewState} className={'modal-xl'} centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">รายละเอียดโครงการ</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setModalViewState(false) }}></button>
                </div>
                <div className='modal-body' style={{ minHeight: '300px' }}>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ชื่อโครงการ :</span>
                        </div>
                        <div className='col-lg-8'>
                            <input type="text" className="form-control"  {...register("ProjectName", { required: false })} />
                        </div>
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>กลุ่มโครงการ :</span>
                        </div>
                        <div className='col-lg-8'>
                            <select className='form-control' onChange={(e) => { setProjectGroupID(e.target.value); }} defaultValue={_ProjectGroupID} >
                                <option value={0}>เลือกกลุ่มโครงการ</option>
                                {_ProjectGroupList.map((v, i) => (
                                    <option value={v.projectGroupId} key={i}>{v.projectGroupName}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>สถานะ :</span>
                        </div>
                        <div className='col-lg-2'>
                            <select className='form-control text-center' onChange={(e) => { setStatus(e.target.value); }} defaultValue={_Status} >
                                <option value={1}>เปิด</option>
                                <option value={0}>ปิด</option>
                            </select>
                        </div>
                        <div className='col-lg-2 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>รหัสเลขประจำตัว :</span>
                        </div>
                        <div className='col-lg-2'>
                            <input type="text" className="form-control"  {...register("CodePrefix", { required: false })} />
                        </div>
                        
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ระดับชั้น :</span>
                        </div>
                        <div className='col-lg-4'>
                            <select className='form-control' onChange={(e) => { setGradeLevel(e.target.value); _LoadCourseList(e.target.value); }} defaultValue={_GradeLevel} >
                                <option value={0}>เลือกระดับชั้น</option>
                                <option value={1}>ชั้นมัธยมศึกษาปีที่ 1</option>
                                <option value={2}>ชั้นมัธยมศึกษาปีที่ 4</option>
                            </select>
                        </div>
                        <div className='col-lg-2 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ปีการศึกษา :</span>
                        </div>
                        <div className='col-lg-2'>
                            <input type="text" className="form-control"  {...register("YearEDU", { required: false })} />
                        </div>
                    </div>

                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>รับระเบียบการ :</span>
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_ApplicationStart} onChange={(c, b) => {
                                setApplicationStart(c);
                            }} />
                        </div>
                        <div className='col-lg-1 text-center'>
                            -
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_ApplicationEnd} onChange={(c, b) => {
                                setApplicationEnd(c);
                            }} />
                        </div>
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>รับสมัคร :</span>
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_SubmitStart} onChange={(c, b) => {
                                setSubmitStart(c);
                            }} />
                        </div>
                        <div className='col-lg-1 text-center'>
                            -
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_SubmitEnd} onChange={(c, b) => {
                                setSubmitEnd(c);
                            }} />
                        </div>
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ประกาศรายชื่อผู้มีสิทธิ์สอบ :</span>
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_CandidateDate} onChange={(c, b) => {
                                setCandidateDate(c);
                            }} />
                        </div>
                    </div>

                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>สอบคัดเลือก :</span>
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_ExamDateStart} onChange={(c, b) => {
                                setExamDateStart(c);
                            }} />
                        </div>
                        <div className='col-lg-2'>
                            <TimePicker format="HH:mm" value={_ExamTimeStart} onChange={(e) => {
                                setExamTimeStart(e)
                            }} />
                        </div>
                        <div className='col-lg-1 text-center'>
                            -
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_ExamDateEnd} onChange={(c, b) => {
                                setExamDateEnd(c);
                            }} />
                        </div>
                        <div className='col-lg-2'>
                            <TimePicker format="HH:mm" value={_ExamTimeEnd} onChange={(e) => {
                                const _m = moment(e);
                                setExamTimeEnd(e)
                            }} />
                        </div>
                    </div>

                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>สอบสัมภาษณ์ :</span>
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_InterviewDateStart} onChange={(c, b) => {
                                setInterviewDateStart(c);
                            }} />
                        </div>
                        <div className='col-lg-2'>
                            <TimePicker format="HH:mm" value={_InterviewTimeStart} onChange={(e) => {
                                setInterviewTimeStart(e)
                            }} />
                        </div>
                        <div className='col-lg-1 text-center'>
                            -
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_InterviewDateEnd} onChange={(c, b) => {
                                setInterviewDateEnd(c);
                            }} />
                        </div>
                        <div className='col-lg-2'>
                            <TimePicker format="HH:mm" value={_InterviewTimeEnd} onChange={(e) => {
                                const _m = moment(e);
                                setInterviewTimeEnd(e)
                            }} />
                        </div>
                    </div>

                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ประกาศผล :</span>
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_ExamResultDate} onChange={(c, b) => {
                                setExamResultDate(c);
                            }} />
                        </div>
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ยืนยันสิทธิ์ :</span>
                        </div>
                        <div className='col-lg-2'>
                            <ThaiDatePicker inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_ConfirmDate} onChange={(c, b) => {
                                setConfirmDate(c);
                            }} />
                        </div>
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>รายละเอียด :</span>
                        </div>
                        <div className='col-lg-8'>
                            <Controller name="Description" control={control} rules={{ required: false }} render={({ field }) => (
                                <textarea className='form-control' rows={5} onChange={(e) => field.onChange(e)} value={field.value}></textarea>
                            )} />
                        </div>
                    </div>
                    <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>วิชาที่สอบ :</span>
                        </div>
                        <div className='col-lg-8'>
                            <input type="text" className="form-control"  {...register("ExamTopic", { required: false })} />
                        </div>
                    </div>
                     <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ค่าธรรมเนียม :</span>
                        </div>
                        <div className='col-lg-2'>
                            <input type="text" className="form-control text-center"  {...register("Price", { required: false })} />
                        </div>
                        <div className='col-lg-2 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>GPAX :</span>
                        </div>
                        <div className='col-lg-1'>
                            <input type="text" className="form-control text-center"  {...register("GPAX", { required: false })} />
                        </div>

                        <div className='col-lg-2 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>ลำดับแสดง :</span>
                        </div>
                        <div className='col-lg-1'>
                            <input type="text" className="form-control text-center"  {...register("Sorting", { required: false })} />
                        </div>
                    </div>
                    <div className='row mt-4 mb-2 justify-content-end'>
                        <div className='col-lg-3 mt-2 mb-2 text-end'>
                            <span className='fw-semibold mt-2'>สามารถเลือกได้ :</span>
                        </div>
                        <div className='col-lg-2'>
                            <input type="number" className="form-control text-center"  {...register("CourseLimit", { required: false })} />
                        </div>
                        <div className='col-lg-6'>
                            <select className='form-control' onChange={(e) => { setCourseID(e.target.value); }} value={_CourseID}  >
                                <option value={null}>เลือกแผนการเรียน</option>
                                ({_CourseList.map((v, i) => {
                                    return (<option value={v.CourseID} key={i}>{v.CourseName}</option>);
                                })})
                            </select>
                        </div>
                        <div className='col-lg-1 text-center'>
                            <button type='button' className='btn btn-success btn-sm' onClick={() => { _CourseAdd(); }}>เพิ่ม</button>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='table-responsive'>
                                <table className='table table-bordered'>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>แผนการเรียน</th>
                                            <th className='text-center' style={{ 'width': '120px' }}>รับจำนวน</th>
                                            <th className='text-center'>#</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_CourseMember.map((v, i) => (
                                            <tr key={i}>
                                                <td>{v.CourseName}</td>
                                                <td className='text-center'>
                                                    <input type="number" className='form-control text-center' defaultValue={v.Seat} onChange={(e) => {
                                                        let _Obj = [..._CourseMember];
                                                        let _Index = _Obj.findIndex((f) => f.CourseID == v.CourseID);
                                                        if (_Index != -1) {
                                                            _Obj[_Index].Seat = Number(e.target.value);
                                                            setCourseMember(_Obj);
                                                        }
                                                        console.log(_Obj);
                                                    }} />
                                                </td>
                                                <td className='text-center'>
                                                    <button type='button' className='btn btn-danger btn-sm' onClick={() => {
                                                        let _Obj = [..._CourseMember];
                                                        let _Index = _Obj.findIndex((f) => f.CourseID == v.CourseID);
                                                        if (_Index != -1) {
                                                            _Obj.splice(_Index, 1);
                                                            setCourseMember(_Obj);
                                                        }
                                                    }}>ลบ</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 text-end'>
                            <div className='btn btn-group'>
                                {(_ProjectID != null ? <button type='button' className='btn btn-info btn-lg text-white' onClick={() => { _PDF(); }}>เปิดไฟล์เอกสาร</button> : "")}
                                {(_ProjectID != null ? <button type='button' className='btn btn-danger btn-lg' onClick={() => { _Upload(); }}>แนบไฟล์เอกสาร</button> : "")}
                                <button type='button' className='btn btn-success btn-lg' onClick={() => { _Save(); }}>บันทึก</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <PDFViewCard ref={_PDFViewCard} />
            <input type='file' onChange={(e) => { _RegisterFileUpload(e) }} ref={_FileInputRef} style={{ display: 'none' }} accept=".png,.pdf,.jpg,.jpeg" />

        </>
    )
});

export default React.memo(ProjectCard)